module.exports = __webpack_public_path__ + "static/img/weixin_code.92e8c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/weixin_code.jpg
// module id = e+zT
// module chunks = 1